module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('rotate-device'), _vm._v(" "), _c('click-fullscreen'), _vm._v(" "), _c('modal'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb8498ac!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 173
// module chunks = 0